import GridDesktopLight from '../assets/background/dashed-grid-light.svg';
import GridDesktopDark from '../assets/background/dashed-grid-dark.svg';

export const backgroundImages = {
  grid: {
    mobile: '',
    tablet: '',
    desktop: GridDesktopLight,
  },
  'grid-light': {
    mobile: '',
    tablet: '',
    desktop: GridDesktopLight,
  },
  'grid-dark': {
    mobile: '',
    tablet: '',
    desktop: GridDesktopDark,
  },
};
